// Scopes blog caches per user and Nexudus host
type BlogsScope = { userId: number | null; host: string };

export const queryKeys = {
  payments: ['payments'] as const,
  invoicePreview: (itemCount: number) =>
    ['payments', 'invoicePreview', itemCount] as const,
  teamDiscount: ['teamDiscount'] as const,
  accountBalance: ['accountBalance'] as const,
  bookings: ['bookings'] as const,
  events: ['events'] as const,
  blogs: ['blogs'] as const,
  featuredBlogs: (scope: BlogsScope) => ['blogs', 'featured', scope] as const,
  blogPostsList: (
    scope: BlogsScope & {
      page: number;
      size: number;
      categoryId: number | null;
      query: string;
    },
  ) => ['blogs', 'list', scope] as const,
};

export const mutationKeys = {
  payments: ['payments'] as const,
  verification: ['verification'] as const,
};
